import * as R from 'ramda';

// Only things that you wish were part of the standard JS API!
// If your code references a single domain concept, it can't go in this folder!

/**
 * Returns whether or not the two arguments are strictly equal (which, in the case of objects, means referential
 * equality) AKA `===` equality
 */
export const strictEquals = (one: any, two: any): boolean => one === two;

/**
 * An occasionally useful function... which does nothing
 */
export const doNothing = () => {};


/**
 * A function that adds the given encoding if an encoding isn't already present in the image data.
 * Defaults to JPEG encoding.
 */
export const addImgEncoding = (
  imgData: string,
  encoding: string = 'data:image/jpeg;base64,',
): string => imgData.startsWith('data') ? imgData : `${encoding}${imgData}`;


export const isNilOrEmpty = (value: any) => R.isEmpty(value) || R.isNil(value);